import { FaYoutube, FaInstagram, FaLinkedinIn } from "react-icons/fa6";
import { YOUTUBE_URL, INSTAGRAM_URL, LINKEDIN_URL } from "@/lib/site";

const cards = [
  { title: "YouTube", href: YOUTUBE_URL, icon: FaYoutube, copy: "Watch plain-English lessons on Family Banking, cash flow, retirement income, protection, and legacy." },
  { title: "LinkedIn", href: LINKEDIN_URL, icon: FaLinkedinIn, copy: "Explore professional insights on financial systems, entrepreneurship, family wealth, and long-term decision-making." },
  { title: "Instagram", href: INSTAGRAM_URL, icon: FaInstagram, copy: "Find short explanations, visual lessons, and practical reminders you can revisit and share." },
];

export const LearningSection = () => (
  <section data-testid="learning-section" className="section-lr bg-legacy text-ivory">
    <div className="container-lr">
      <div className="mx-auto max-w-3xl text-center">
        <div className="flex items-center justify-center gap-4"><span className="gold-rule" /><p className="eyebrow text-gold">Learn at Your Own Pace</p><span className="gold-rule" /></div>
        <h2 className="section-heading mt-6 text-ivory">Start with the <span className="accent-word">Problem</span> You&rsquo;re Trying to Solve.</h2>
        <p className="mt-5 text-lg leading-relaxed text-taupe">Knowledge becomes valuable when it is consistently understood and applied.</p>
        <p className="mt-4 text-base leading-relaxed text-taupe/90">Financial clarity grows through repetition. Continue learning through videos, practical conversations, and short explanations designed to help families make more confident decisions.</p>
      </div>
      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {cards.map(({ title, href, icon: Icon, copy }) => (
          <a key={title} href={href} target="_blank" rel="noopener noreferrer" aria-label={`Visit Legacy Life & Retirement on ${title}`} className="lr-card group bg-white/[0.04] p-7 text-left text-ivory border-ivory/12 focus-ring">
            <Icon size={30} className="text-gold" />
            <h3 className="mt-6 font-serif text-2xl text-ivory">{title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-taupe">{copy}</p>
          </a>
        ))}
      </div>
    </div>
  </section>
);
